












import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ModalHeader extends Vue {
  @Prop(String) readonly modalName!: string;
  hide() {
    this.$modal.hide(this.modalName);
    this.$emit("hide-modal");
  }
}
